import angular from 'angular';
import UIRouter from 'angular-ui-router';

import './styles/index.scss';
import template from './index.html';
import ReportController from './ReportController';

    
let namespace = angular.module('olr-mainfe-reports', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.reports', {
    url: '/reports',
    controller: ReportController,
    controllerAs: 'reportCtrl',
    template: template
  });
});

namespace.controller('ReportController', ReportController);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-reports/index.js
 **/